module.exports = __webpack_public_path__ + "public/images/header/user-icon.c7c29cadb29f0104c67141c214227926.svg";